import type { StackProps } from '@chakra-ui/react'
import type { LexicalEditor } from 'lexical'
import { forwardRef } from 'react'

import RichTextInput from '@app/next/forms/inline/richTextInput'
import WithLabel from '@app/next/forms/withLabel'
import type { DomainObject } from '@app/types'

interface Props {
  domainObject: DomainObject
  name: string
  label: string
  placeholder?: string
  domainObjectUpdateId?: string
  stackProps?: StackProps
}

const RichTextInputWithLabel = forwardRef<LexicalEditor, Props>(
  ({ domainObject, name, placeholder, label, domainObjectUpdateId, stackProps = {} }, ref) => {
    const domainObjectValue = domainObject[name]

    return (
      <WithLabel label={label} showLabel={!!domainObjectValue} stackProps={stackProps}>
        <RichTextInput
          domainObject={domainObject}
          name={name}
          placeholder={placeholder}
          domainObjectUpdateId={domainObjectUpdateId}
          ref={ref}
        />
      </WithLabel>
    )
  }
)

export default RichTextInputWithLabel
